import React from 'react'
import { compose } from 'recompose'
import { qrcode } from 'react-icons-kit/icomoon/qrcode'

import { withModal } from '../../../modules/modal/withModal'
import DynamicLinkModalContainer from './DynamicLinkModalContainer'
import { Icon } from 'react-icons-kit/Icon'

class DynamicLinkButton extends React.Component {
  state = {}

  handleShowModal = () => {
    this.props.showModal()
  }

  render() {
    return (
      <DynamicLinkViewButton onShowModal={this.handleShowModal}>
        QR code
      </DynamicLinkViewButton>
    )
  }
}

const DynamicLinkViewButton = ({ children, haveQuota, onShowModal }) => (
  <a className="navbar-item" onClick={onShowModal}>
    <span className="icon">
      <Icon icon={qrcode} />
    </span>
    <span>{children}</span>
  </a>
)

export default compose(withModal(DynamicLinkModalContainer))(DynamicLinkButton)



// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/DynamicLinkButton.js